import React from 'react'

export default function ({
  label,
  value,
  onChange,
  border = 'none',
  labelColor = 'rgba(255,255,255,0.7)',
  marginTop = 20,
  items = [],
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
    },
    input: {
      width: '100%',
      outline: 'none',
      border,
      height: 35,
      marginTop: 3,
      backgroundColor: 'rgba(255,255,255,0.9)',
      padding: 10,
    },
    option: {
      // fontSize: '0.625rem'
    },
  }
  return (
    <div style={styles.container}>
      <label style={styles.label} htmlFor="mySelect">
        {label}
      </label>
      <select
        style={styles.input}
        name="mySelect"
        value={value}
        onChange={evt => onChange(evt.target.value)}
      >
        {items.map(item => (
          <option style={styles.option} key={item.id} value={item.id}>
            {item.value}
          </option>
        ))}
      </select>
    </div>
  )
}
